import {
  Settings,
  LogOut,
  User,
  Moon,
  Sun,
  Home,
  FolderGit2,
  AlertTriangle,
  BarChart,
  ChevronLeft,
  ChevronRight,
  ShieldAlert,
  CreditCard,
  Search,
  AlertOctagon,
  Info,
  AlertCircle,
  History,
  CheckCircle2,
  XCircle,
  Clock,
  FileCode,
  GitBranch,
  GitPullRequest,
  Tag,
  Calendar,
  MessageSquare,
  Activity,
  Link,
  Copy,
  ExternalLink,
  RefreshCw,
  Sparkles,
  GitCommit,
  Lock,
  ArrowLeft,
  Shield,
  CheckCircle,
  HelpCircle,

  Zap
} from 'lucide-react';

import {
  GitBranch as PhGitBranch,
  LockKey as PhLockKey,
  ChartBar as PhChartBar,
  Pulse as PhPulse
} from '@phosphor-icons/react';

export const Icons = {
  // Navigation & UI (Lucide)
  Dashboard: Home,
  Repositories: FolderGit2,
  Scans: Activity,
  Issues: AlertTriangle,
  Reports: BarChart,
  Settings: Settings,
  Billing: CreditCard,
  Admin: ShieldAlert,
  Profile: User,
  Logout: LogOut,
  ThemeLight: Sun,
  ThemeDark: Moon,
  Search: Search,
  History: History,
  ChevronLeft: ChevronLeft,
  ChevronRight: ChevronRight,
  Back: ArrowLeft,
  Help: HelpCircle,

  // Security & Remediation (Lucide)
  AlertTriangle: AlertTriangle,
  Shield: Shield,
  CheckCircle: CheckCircle,
  SecurityWarning: AlertTriangle,

  // Severity (Lucide)
  Critical: AlertOctagon,
  High: AlertTriangle,
  Medium: Info,
  Low: Info,
  
  // Status (Lucide)
  StatusOpen: AlertCircle,
  StatusResolved: CheckCircle2,
  StatusIgnored: XCircle,
  StatusWontFix: XCircle,
  StatusPending: Clock,

  // Stats (Phosphor Duotone - used in RepositoryStatsCards)
  StatRepo: PhGitBranch,
  StatPrivate: PhLockKey,
  StatSize: PhChartBar,
  StatActivity: PhPulse,
  
  // Misc Issue Details (Lucide)
  FileCode: FileCode,
  GitBranch: GitBranch,
  GitPullRequest: GitPullRequest,
  Tag: Tag,
  Calendar: Calendar,
  Comments: MessageSquare,
  Activity: Activity,
  Link: Link,
  Copy: Copy,
  ExternalLink: ExternalLink,
  Refresh: RefreshCw,
  AI: Sparkles,
  Commit: GitCommit,
  Lock: Lock,
  Zap: Zap,
};
